/*
 * Fila de tarjetas por Año del DO, réplica del .year-card del HTML original
 * (hover con elevación y borde del color del año)
 */
import { useState } from "react";
import { Description, Title } from "codekit";

import { carteraColors, fmtCOP, htmlTheme } from "./utils/carthelp";

/**
 * Renderiza las tarjetas de valor pendiente por año
 * @param {Object} props Propiedades del componente
 * @param {Array} props.years Lista [{ year, valor, count }]
 * @param {Function} props.onYearClick Callback con el año al hacer click
 */
const Yearcard = ({ years = [], onYearClick }) => {
  const [nHover, setHover] = useState(null);

  return (
    <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
      {years.map((mItem, nIndex) => {
        const sColor = carteraColors[nIndex % carteraColors.length];
        const bHover = nHover === nIndex;
        return (
          <div
            key={mItem.year}
            onClick={() => onYearClick(mItem.year)}
            onMouseEnter={() => setHover(nIndex)}
            onMouseLeave={() => setHover(null)}
            style={{
              flex: 1,
              minWidth: 130,
              background: htmlTheme.card,
              border: `2px solid ${bHover ? sColor : htmlTheme.border}`,
              borderTop: `5px solid ${sColor}`,
              borderRadius: 12,
              padding: "14px 16px",
              textAlign: "center",
              cursor: "pointer",
              transition: "all .15s ease",
              transform: bHover ? "translateY(-3px)" : "none",
              boxShadow: bHover ? "0 6px 16px rgba(20,30,70,.12)" : "none",
            }}
          >
            <div style={{ color: sColor }}>
              <Title variant="title-3">{mItem.year}</Title>
            </div>
            <div style={{ color: htmlTheme.navy2, marginTop: 4 }}>
              <Title variant="title-2">{fmtCOP(mItem.valor)}</Title>
            </div>
            <div style={{ color: htmlTheme.muted, marginTop: 2 }}>
              <Description variant="description-4">{mItem.count} DO</Description>
            </div>
            <div style={{ color: sColor, marginTop: 4, fontWeight: 700 }}>
              <Description variant="description-4">Ver detalle ›</Description>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Yearcard;
